import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Topnav from "./Topnav";
import Footer from "./Footer";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import TelegramIcon from "@mui/icons-material/Telegram";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

// Placeholder handles — swap for MEESOK.COM's real LINE/Telegram
// accounts before this page ships.
const CONTACT_CHANNELS = [
  { id: "line-1", type: "line", handle: "@MEESOK_LINE1" },
  { id: "line-2", type: "line", handle: "@MEESOK_LINE2" },
  { id: "telegram-1", type: "telegram", handle: "meesok_support" },
];

function ChannelBadge({ type }) {
  const isTelegram = type === "telegram";
  return (
    <div
      className={
        "flex items-center gap-1.5 rounded-lg px-3 py-1.5 " +
        (isTelegram ? "bg-[#229ED9]" : "bg-[#06C755]")
      }
    >
      {isTelegram ? (
        <TelegramIcon className="text-white" fontSize="small" />
      ) : (
        <ChatBubbleIcon className="text-white" fontSize="small" />
      )}
      <span className="font-heading font-extrabold text-white text-sm tracking-wide">
        {isTelegram ? "TELEGRAM" : "LINE ID"}
      </span>
    </div>
  );
}

function ContactChannelCard({ channel, t }) {
  const caption =
    channel.type === "telegram"
      ? t("contact.telegramChannel")
      : t("contact.lineChannel");
  return (
    <motion.div
      whileHover={{ y: -4, scale: 1.02 }}
      className="flex flex-col items-center gap-3 rounded-card border border-brand-gold-300/40 bg-brand-blue-900/60 p-4 shadow-cardLight transition-shadow hover:shadow-card"
    >
      <span className="text-[11px] text-white/50 font-body text-center">
        {caption}
      </span>
      <ChannelBadge type={channel.type} />
      <span className="font-heading font-bold text-brand-gold-200 text-base">
        {channel.handle}
      </span>
    </motion.div>
  );
}

function Contact() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col min-h-screen">
      <Topnav />
      <div className="content flex-1">
        <div className="xl:w-[75%] w-[90%] mt-10 xl:mt-[100px] flex flex-col gap-3">
          <Link
            to="/"
            className="self-start inline-flex items-center gap-1 rounded-pill border border-brand-gold-300/60 bg-brand-blue-900/70 px-4 py-2 text-white/90 text-sm font-body hover:bg-brand-blue-800 transition-colors"
          >
            <ArrowBackIosIcon sx={{ fontSize: 12 }} />
            {t("contact.backToHome")}
          </Link>

          <div className="flex flex-col items-center gap-6 rounded-card border-2 border-brand-gold-300/70 bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 p-6 shadow-card">
            <h1 className="font-heading font-extrabold text-brand-gold-300 text-2xl xl:text-3xl text-center">
              {t("contact.channelListTitle")}
            </h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
              {CONTACT_CHANNELS.map((channel) => (
                <ContactChannelCard key={channel.id} channel={channel} t={t} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
